import React, { useState } from "react";
import {
    Card,
    CardBody,
    CardTitle,
    Row,
    Col,
    CardFooter,
} from "reactstrap";
import moment from 'moment';
// reactstrap components
import { useQuery } from 'react-query';
import { getDeviceParameter } from "API";
import SuspenseComponentText from '../../../views/components/SuspenseComponentText';

const staticParamTitles = {
    technical_break: "Technical Break",
    buy_rent: "Buy&Rent",
    swap: "Swap",
    return: "Return",
    columns_max_capacity: "Columns Max Capacity",
    price: "Price",
    price_rent: "Price Rent",
    deposit_value: "Deposit Value",
    column_critical_value: "Column Critical Value",
    terminal_serial: "Terminal Serial",
    client: "Client",
    fontColor: "fontColor",
    fontSecondaryColor: "fontSecondaryColor",
    fontTertiaryColor: "fontTertiaryColor",
    backgroundColor: "backgroundColor",
    buttonBackgroundColor: "buttonBackgroundColor",
    buttonFontColor: "buttonFontColor",
    support_phone_number: "Support Phone Number",
}

const COLUMN_PARAM_RE = /^column(\d+)(_status|_quantity)?$/;

const getParamTitle = (nameParam) => {
    const match = nameParam?.match(COLUMN_PARAM_RE);
    if (match) {
        const [, index, suffix] = match;
        if (suffix === '_status') return `Column ${index} Status`;
        if (suffix === '_quantity') return `Column ${index} Quantity`;
        return `Column ${index} Status & Quantity`;
    }
    return staticParamTitles[nameParam] ?? nameParam;
}


const DeviceDetailsParameter = ({ serial, nameParam , elSize, elColor }) => {
    const [dataParameter, setDataParameter] = useState(null);
    const dataGetParameter = useQuery(nameParam, () => getDeviceParameter(serial, nameParam), {
        refetchInterval: 60000,
        onSuccess: (data) => {

            setDataParameter(data.data.value);
        }
    });

    const handleDataParameter = () => {
        if (nameParam === 'technical_break') {
            return dataParameter === '0' ? 'Off' : 'On'
        }
        else if (nameParam === 'price' || nameParam === 'price_rent' || nameParam === 'deposit_value') {
            return `${dataParameter} £`
        }
        else if (/^column\d+_status$/.test(nameParam)) {
            return dataParameter === '0' ? 'Inactive' : 'Active'
        }
        else {
            return dataParameter
        }
    }


    return (
        <>
            <Col lg={elSize} md={elSize}>
                <Card className="card-stats">
                    <CardBody>
                        <Row>
                            <Col xs="3">
                                <div className={`info-icon text-center icon-${elColor}`}>
                                    <i className="tim-icons icon-components" />
                                </div>
                            </Col>
                            <Col xs="9">
                                <div className="numbers">
                                    <p className="card-category">{getParamTitle(nameParam)}</p>
                                    <CardTitle tag="h3">
                                        {dataGetParameter.isLoading ? <SuspenseComponentText /> :
                                            dataGetParameter.isError ? `Error` : handleDataParameter()
                                        }
                                    </CardTitle>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter>
                        {/* <hr />
                        <div className="stats">
                            <i className="tim-icons icon-alert-circle-exc" />
                            {dataGetParameter.isLoading ? <SuspenseComponentText /> :
                                dataGetParameter.isError ? `Error` : null
                            }
                        </div> */}
                    </CardFooter>
                </Card>
            </Col>
        </>
    )
}

export default DeviceDetailsParameter;